import * as R from 'ramda'
import { RSAA } from 'redux-api-middleware'

/**
 * if this is an RSAA action (for API requests), this
 * middleware will actually load mockup data from a
 * given path and return it as the success payload.
 *
 * in production builds, the mockup data is removed
 * to avoid any errors and the actual api call is made.
 */
export default () => next => action => {
  const fluxAction = action[RSAA]

  if (fluxAction && R.has('mockup', fluxAction)) {
    if (process.env.REACT_APP_BUILD_ENV === 'production') {
      const { mockup, ...validAction } = fluxAction
      return next({ [RSAA]: validAction })
    } else {
      const {
        mockup,
        endpoint,
        types: [requestType, maybeSuccessType, failureType],
        ...otherActionProps
      } = fluxAction

      // this allows us to mock all methods using a
      // fetch property on RSAA. However the limitation here
      // is that we can't mock authentication endpoints, i.e.,
      // endpoints that return a token since the hardcoded token
      // we'd mock is not what BE would have stored in Redis cache
      const nextAction = {
        [RSAA]: {
          endpoint: '/',
          fetch: async () =>
            new Response(JSON.stringify(mockup), {
              status: 200,
              headers: {
                'content-type': 'application/json',
              },
            }),
          ...otherActionProps,
          types: [requestType, maybeSuccessType, failureType],
        },
      }

      return next(nextAction)
    }
  } else {
    return next(action)
  }
}
